import React, { useEffect, useState } from 'react';
import { confirmPasswordReset, verifyPasswordResetCode } from 'firebase/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../../../firebase';
import { useLanguage } from '../../../context/LanguageContext.jsx';
import '../Auth.css';

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isEnglish } = useLanguage();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isValidCode, setIsValidCode] = useState(false);

  useEffect(() => {
    document.title = isEnglish ? 'Reset Password | INTEGRA' : 'Şifre Sıfırlama | INTEGRA';
    const params = new URLSearchParams(location.search);
    const oobCode = params.get('oobCode');

    if (!oobCode) {
      setError(isEnglish ? 'Reset code not found.' : 'Şifre sıfırlama kodu bulunamadı.');
      setTimeout(() => navigate('/'), 2500);
      return;
    }

    verifyPasswordResetCode(auth, oobCode)
      .then(() => setIsValidCode(true))
      .catch(() => {
        setError(isEnglish ? 'Reset link is invalid or expired.' : 'Şifre sıfırlama bağlantısı geçersiz veya süresi dolmuş.');
        setTimeout(() => navigate('/'), 2500);
      });
  }, [isEnglish, location.search, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError(isEnglish ? 'Passwords do not match.' : 'Şifreler eşleşmiyor.');
      return;
    }

    const params = new URLSearchParams(location.search);
    const oobCode = params.get('oobCode');

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      setMessage(isEnglish ? 'Password changed successfully.' : 'Şifreniz başarıyla değiştirildi.');
      setTimeout(() => navigate('/giriş-yap'), 2500);
    } catch (err) {
      setError(
        (isEnglish ? 'Error while changing password: ' : 'Şifre değiştirme hatası: ') +
          (err?.message || String(err))
      );
    }
  };

  if (!isValidCode) {
    return (
      <div className="auth-container reset-password-container">
        <h2>{isEnglish ? 'Reset Password' : 'Şifre Sıfırlama'}</h2>
        {error && <div className="error-message">{error}</div>}
      </div>
    );
  }

  return (
    <div className="auth-container reset-password-container">
      <h2>{isEnglish ? 'Enter Your New Password' : 'Yeni Şifrenizi Giriniz'}</h2>
      {message && <div className="success-message">{message}</div>}
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder={isEnglish ? 'New Password' : 'Yeni Şifre'}
          required
        />
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder={isEnglish ? 'Confirm New Password' : 'Yeni Şifre (Tekrar)'}
          required
        />
        <button type="submit" className="reset-password-btn">
          {isEnglish ? 'Change Password' : 'Şifreyi Değiştir'}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;

